export var SubstructureVariant;
(function (SubstructureVariant) {
    /**
     * Defaults
     */
    SubstructureVariant["Default"] = "default";
    /**
     * Display inside the parent configuration
     *
     * Needs unlimited maxDepth to work properly
     */
    SubstructureVariant["Embedded"] = "embedded";
    /**
     * Entering substructure
     */
    SubstructureVariant["Stub"] = "stub";
    /**
     * Display a single substructure without controls
     */
    SubstructureVariant["Content"] = "content";
})(SubstructureVariant || (SubstructureVariant = {}));
export var SubstructureInstanceButton;
(function (SubstructureInstanceButton) {
    SubstructureInstanceButton["Edit"] = "edit";
    SubstructureInstanceButton["Delete"] = "delete";
    SubstructureInstanceButton["Insert"] = "insert";
    SubstructureInstanceButton["Copy"] = "copy";
    SubstructureInstanceButton["MoveDown"] = "moveDown";
    SubstructureInstanceButton["MoveUp"] = "moveUp";
    SubstructureInstanceButton["Status"] = "status";
    SubstructureInstanceButton["Reset"] = "reset";
})(SubstructureInstanceButton || (SubstructureInstanceButton = {}));
/**
 * Default order of instance buttons
 */
export const DEFAULT_SUBSTRUCTURE_INSTANCE_BUTTON_ORDER = [
    SubstructureInstanceButton.Edit,
    SubstructureInstanceButton.Delete,
    SubstructureInstanceButton.Insert,
    SubstructureInstanceButton.Copy,
    SubstructureInstanceButton.MoveDown,
    SubstructureInstanceButton.MoveUp,
    SubstructureInstanceButton.Reset,
    SubstructureInstanceButton.Status,
];
export var SubstructureElement;
(function (SubstructureElement) {
    SubstructureElement["InstanceList"] = "InstanceList";
    SubstructureElement["AddButton"] = "AddButton";
})(SubstructureElement || (SubstructureElement = {}));
export const DEFAULT_SUBSTRUCTURE_ELEMENT_ORDER = [
    SubstructureElement.AddButton,
    SubstructureElement.InstanceList,
];
export const DEFAULT_SUBSTRUCTURE_LAYOUT_PROPS = {
    variant: SubstructureVariant.Default,
    defaultExpanded: false,
    elementOrder: DEFAULT_SUBSTRUCTURE_ELEMENT_ORDER,
    instanceButtonOrder: DEFAULT_SUBSTRUCTURE_INSTANCE_BUTTON_ORDER,
    custom: {},
};
//# sourceMappingURL=SubstructureLayout.js.map